import React, { Component } from "react";
import {
  profile,
  branch,
  alert,
  total,
  float,
  toFixed,
  format_date,
  random_charactor,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  Status,
  params,
  required,
  DatePicker,
  Select,
  BtnIcon,
  Swal,
  Pagination,
  Switch,
  Navbar,
  Modal,
  Resizer,
} from "../components/CustomComponent.js";
import { report_get_spare_parts } from "../components/Report.js";
export default class PaymentHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      document_no: "",
      repair_document_no: "",
      repair_car_registration: "",
      repair_model: "",
      repair_cause: "",


      created_at: "",

      warehouse_name: "",
      destination_warehouse_name: "",

      transaction_list: [],
    };
  }

  async componentDidMount() {
    loading(false);
    if (params("uid")) {
      await this.Get(params("uid"));
    }
    // window.print();
  }

  Get = async (uid) => {
    loading(true);
    let result = await GET("admin/stock-activities/list", { uid });
    if (result?.status) {
      const item = result.data;
      const data = {
        document_no: item.document_no,
        repair_document_no: item.repair?.document_no || "",
        repair_car_registration: item.repair?.car_registration || "",
        repair_model: item.repair?.model || "",
        repair_cause: item.repair?.cause || item?.remark || "",
        created_at: item.created_at,
        transaction_list: item.transaction_list || [],

        warehouse_name: item.warehouse?.name || "",
        destination_warehouse_name: item.destination_warehouse?.name || "",
      }
      this.setState(data);
      await report_get_spare_parts(data);
      setTimeout(() => {
        
    window.close();
      }, 200);
    }
    loading(false);
  };
  render() {
    const {
      document_no,
      repair_document_no,
      repair_car_registration,
      repair_model,
      repair_cause,
      created_at,
      transaction_list,
      warehouse_name,
      destination_warehouse_name,
    } = this.state;
    return (
      <div></div>
      // <div className="mx-auto bg-white p-5 pdf" style={{ width: 446 }}>
      //   <h4 className="fw-bold text-center mb-3">บิลเบิกอะไหล่ ซ่อม-ติดตั้ง</h4>
      //   <div className="w-100 fw-bold mb-3">เลขที่ใบเบิก : {document_no}</div>
      //   <div className="w-100 fw-bold mb-3">
      //     วันที่ : {format_date(created_at, "dd mmmm yyyy", "th")}
      //   </div>
      //   <div className="fw-bold mb-3">
      //     เลขที่แจ้งซ่อม : {repair_document_no}
      //   </div>
      //   <div className="w-100 fw-bold mb-3">
      //     คลังสินค้าต้นทาง : {warehouse_name}
      //   </div>
      //   <div className="w-100 fw-bold mb-3">
      //     คลังสินค้าปลายทาง : {destination_warehouse_name}
      //   </div>
      //   <hr />
      //   {transaction_list?.map((item, index) => (
      //     <div className="mb-4 d-flex justify-content-between" style={{fontSize:18}}>
      //       <div>
      //         {item.product_name} {item.remark ? `(${item.remark})` : ""}
      //       </div>
      //       <div>
      //           X{item.qty}
      //         </div>
      //     </div>
      //   ))}
      //   <hr />
      //   <div className="fw-bold mb-3">สาเหตุ : {repair_cause}</div>
      //   <div className="d-flex justify-content-between mb-3">
      //     <div className="w-100">
      //       <div className="fw-bold mb-3">ซ่อม</div>
      //       <div className="fw-bold mb-3">
      //         ทะเบียน : {repair_car_registration} {repair_model}
      //       </div>
      //     </div>
      //     <div className="w-100">
      //       <div className="fw-bold mb-3">ติดตั้ง</div>
      //     </div>
      //   </div>
      //   <div className="text-center my-4">
      //     <div className="fw-bold mb-3">
      //       ลงชื่อ......................................................................ผู้จ่ายของ
      //     </div>
      //     <div className="fw-bold mb-3 me-5">
      //       (...........................................................................)
      //     </div>
      //     <div className="fw-bold mb-3">
      //       วันที่..................................................................................
      //     </div>
      //   </div>
      //   <div className="text-center mt-5">
      //     <div className="fw-bold mb-3">
      //       ลงชื่อ......................................................................ผู้รับของ
      //     </div>
      //     <div className="fw-bold mb-3 me-4">
      //       (...........................................................................)
      //     </div>
      //     <div className="fw-bold mb-3">
      //       วันที่..................................................................................
      //     </div>
      //   </div>
      // </div>
    );
  }
}
